import { Col, Label, Row } from "reactstrap";

//Common
import { fn_getTipoPagamento, fn_getTipoValor } from "@/common/siig";

//Telas
import TPagamentos_list from "../pagamentos/pagamentos_list";

function TSolicitacao_det_aba_pag({ solicitacao, numPag }) {
  return (
    <div className="m-1">
      <div className="mt-2 mb-1">
        <Row className="mb-2">
          <Col sm="3" md="3" lg="3">
            <div className="d-flex align-items-center">
              <Label className="fw-bold mb-0 me-2">Tipo pagamento:</Label>
              {fn_getTipoPagamento(solicitacao.tipo_pagamento)?.label}
            </div>
          </Col>

          <Col sm="2" md="2" lg="2">
            <div className="d-flex align-items-center">
              <Label className="fw-bold mb-0 me-2">Tipo valor:</Label>
              {fn_getTipoValor(solicitacao.tipo_valor_pagamento)?.label}
            </div>
          </Col>

          <Col>
            <div className="d-flex align-items-center">
              <Label className="fw-bold mb-0 me-2">Emissão (dias antes):</Label>
              {solicitacao.dias_ant_emissao}
            </div>
          </Col>
        </Row>

        {solicitacao.obs_pagamento && (
          <Row>
            <Col>
              <div className="d-flex align-items-center">
                <Label className="fw-bold mb-0 me-2">Observação:</Label>
                {solicitacao.obs_pagamento}
              </div>
            </Col>
          </Row>
        )}
      </div>

      <TPagamentos_list solicitacao={solicitacao} numPag={numPag} />
    </div>
  );
}

export default TSolicitacao_det_aba_pag;
